import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LinesPopDto } from '../data/models/lines-pop-dto';
import { StatusClassService } from './status-class.service';

@Injectable({
  providedIn: 'root'
})
export class MarkerPopupService {

  constructor(private htpp: HttpClient, private classStatusService: StatusClassService) { }


  makePopup(data: LinesPopDto[]) {

    if (data.length==0) {
      return ` There is No Lines`;
    }
    return `` +
      `<table class='table table-borderless'  >
        <thead>
          <tr>
             <th class="col-2"><strong> Line Name</strong> </th>
             <th class="col-2"><strong> Status </strong></th>
          </tr>

        </thead>
        <tbody>
         ${this.buildHtmlTable(data)}

  
        </tbody>

       </table>`;
  }


  buildHtmlTable(data) {
    var rowList: string='';
    for (var i = 0; i < data.length; i++) {
      var statusName = (data[i].lineStatus == 0) ? 'Down' : (data[i].lineStatus == 1) ? 'Up' : (data[i].lineStatus == 2) ? 'ParentDown' : (data[i].lineStatus == 3) ? 'Maintenance' :'un-Known';
      var color = (data[i].lineStatus == 0) ? 'red' : (data[i].lineStatus == 1) ? 'green' : (data[i].lineStatus == 2) ? 'red' : (data[i].lineStatus == 3) ? 'orange' : 'gray';
      var row = `
      <tr>
        <td style="color:${color}"><strong>${data[i].lineName}</strong> </td>
        <td style="color:${color}"> <i class="fas fa-desktop ${this.classStatusService.getViewClass(data[i])}"></i>&nbsp; ${statusName} </td>

      </tr>`;
      rowList += row;
    }
    return rowList;
  }

}
